import { Autoplay, Pagination, Thumbs } from "swiper11/modules";
import { createdThumbs, handleSendInquiry } from "../common";
import Swiper from "swiper11";
import dialogFormInit from "../components/dialogForm-1";

const _productDetail02 = () => {
  common();
  function common() {
    initSwiper()
    initEvent()
  }
  function initSwiper() {
    new Swiper(".productDetail-2 .productDetail-2_header .main-swiper .swiper", {
      modules: [Pagination, Autoplay, Thumbs],
      loop: true,
      autoplay: {
        disableOnInteraction: false,
      },
      speed: 650,
      spaceBetween: 30,
      pagination: {
        el: ".productDetail-2 .productDetail-2_header .main-swiper .swiper-pagination",
        type: "custom",
        renderCustom: (swiper, current, total) => {
          return `
      <div class='custom-pagination-content'>
      <span class='current'>${current}</span>
      <span class='total'> / ${total}</span>
      </div>
      `;
        },
      },
      on: {
        beforeInit: (swiper) => {
          createdThumbs(swiper, ".productDetail-2 .productDetail-2_header .thumbs-swiper .swiper", {
            swiperOptions: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
          });
        },
      },
    });
  }
  function initEvent() {
    dialogFormInit();
    handleSendInquiry({ formId: "#Inquiry-form", trigger: "#Inquiry-submit" });
    $(".productDetail-2 .productDetail-2_detail header > .list > li").on("click", (e) => {
      $(".productDetail-2 .productDetail-2_detail header > .list > li").removeClass("active");
      $(e.currentTarget).addClass("active");
    });
  }
}

export default _productDetail02;